import placeholderImage from '../assets/graphics/fallback-headshot-4_3.png';
import placeholderImageWta from '../assets/graphics/wta-fallback.svg';

/**
 * Gets the image URL with the correct dimensions and tenant params.
 * Handles both ODIR URLs and URLs with {odir_width}/{odir_height} placeholders.
 *
 * @param {string} imgUrl image base URL
 * @param {number} [width] image width
 * @param {number} [height] image height
 * @returns {string} processed image URL
 */
export const getImageUrl = (imgUrl, width = '', height = '') => {
    if (imgUrl?.includes('blob:')) {
        return imgUrl;
    }

    const tenant = window?.PLAYBOOK_CONFIG?.tenant
        ? window.PLAYBOOK_CONFIG.tenant
        : window?.PLAYBOOK_TENANT;

    // Check if URL contains placeholders
    const hasWidthPlaceholder = imgUrl.includes('{odir_width}');
    const hasHeightPlaceholder = imgUrl.includes('{odir_height}');

    if (hasWidthPlaceholder || hasHeightPlaceholder) {
        // Replace or remove placeholders
        let processedUrl = imgUrl;
        if (hasWidthPlaceholder) {
            processedUrl = processedUrl.replace('{odir_width}', width || '');
        }
        if (hasHeightPlaceholder) {
            processedUrl = processedUrl.replace('{odir_height}', height || '');
        }
        return processedUrl;
    }

    // Default ODIR handling
    return `${imgUrl}?width=${width}&tenant=${tenant}`;
};

/**
 * On error image helper/handler
 * Sets a placeholder image if the image fails to load
 *
 * @param {object} event the browser event
 * @returns {void} sets the image src to a placeholder on error
 */
export const onErrorImage = (event) => {
    const isWta = window.location.host.includes('wta');

    event.target.src = isWta ? placeholderImageWta : placeholderImage;
};
